<template>
  <div class="page">
    <div class="ctrl">
      <a-button type="primary" @click="show_create = true">添加环节</a-button>
    </div>
    <a-table
      class="sec"
      size="small"
      :rowKey="(record) => record.id"
      bordered
      :columns="columns"
      :data-source="list"
      :pagination="false"
    >
      <template slot="self" slot-scope="text, record">
        {{ record._key }}
        ：
        {{ record._val }}
      </template>

      <template slot="time" slot-scope="text, record">
        {{ record.start_time }}
        --
        {{ record.end_time }}
      </template>


      <template slot="need_join" slot-scope="text, record">
        <a-icon v-if="record.need_join" type="check" />
      </template>

      <template slot="need_app" slot-scope="text, record">
        <a-icon v-if="record.need_app" type="check" />
      </template>

      <template slot="action" slot-scope="text, record">
        <a href="javascript:;" @click="update(record)">编辑</a>
        <a-divider type="vertical" />

        <a-popconfirm
          title="确定要删除吗"
          ok-text="删除"
          cancel-text="取消"
          @confirm="updateStatus(record.id, 0)"
        >
          <a href="javascript:;">删除</a>
        </a-popconfirm>
      </template>
    </a-table>

    <CreateModal v-if="show_create" @callback="created" />
    <UpdateModal v-if="updateModal.show" :oldData="updateModal.data" @callback="updated" />


  </div>
</template>

<style lang='scss' scoped>
</style>

<script>
import CreateModal from "./create";
import UpdateModal from "./update";

const columns = [
  {
    title: "#",
    dataIndex: "id",
  },
  {
    title: "环节",
    dataIndex: "sec_name",
  },
  {
    title: "简介",
    dataIndex: "desc",
  },
  {
    title: "自定义字段",
    scopedSlots: {
      customRender: "self",
    },
  },
  {
    title: "时间",
    scopedSlots: {
      customRender: "time",
    },
  },
  {
    title: "操作",
    scopedSlots: {
      customRender: "action",
    },
  },
];

export default {
  components: { CreateModal, UpdateModal },
  data() {
    return {
      columns,
      activity_id: null,
      list: [],
      show_create: false,
      updateModal: {
        show: false,
        data: {}
      }
    };
  },
  created() {
    this.activity_id = this.$route.query.activity_id;
    this.getList();
  },
  methods: {
    changePage(e) {
      this.page.now_page = e;
      this.getList();
    },

    async getList() {
      if (!this.activity_id) return;
      const r = await this.$axios.get("/activity/section/getList", {
        params: {
          activity_id: this.activity_id,
        },
      });

      if (r.status != 1) return;
      this.list = r.list;
    },

    async updateStatus(id, status) {
      const r = await this.$axios.post("/activity/section/updateStatus", {
        id,
        status,
      });

      if (r.status == 1) this.getList();
    },

    created(e) {
      this.show_create = false;
      if (e) this.getList();
    },

    update (item) {
      this.updateModal = {
        show: true,
        data: item
      }
    },

    updated (e) {
      this.updateModal = {
        show: false,
        data: {}
      }
      if (e) this.getList();
    }
  },
};
</script>